import LandingPageShell from "@/components/landing-page/layout/LandingPageShell";
import AboutMission from "@/components/about/AboutMission";
import OurStory from "@/components/about/OurStory";
import OurTeam from "@/components/about/OurTeam";
import GlobalFootprint from "@/components/about/GlobalFootprint";

export default function AboutPage() {
  return (
    <LandingPageShell>
      <AboutMission />
      <OurStory />
      <OurTeam />
      <GlobalFootprint />
    </LandingPageShell>
  );
}
